import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { worksData } from '../../mocks/works';
import { useSEO } from '../../utils/seo';

const WorksPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useSEO({
    title: '制作実績｜岡山市の印刷会社 おかやま印刷株式会社',
    description: '卒団記念品、販促物、オリジナルグッズなど、おかやま印刷株式会社の制作実績をご紹介します。マグカップ、Tシャツ、ステンレスボトルなど多彩な印刷実績をご覧ください。',
    keywords: '制作実績,印刷実績,記念品,販促物,マグカップ,Tシャツ,岡山市,おかやま印刷',
    canonical: '/works',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '制作実績',
      description: '卒団記念品、販促物、オリジナルグッズなど、おかやま印刷株式会社の制作実績をご紹介します。',
      provider: {
        '@type': 'LocalBusiness',
        name: 'おかやま印刷株式会社',
      },
    },
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-primary via-[#FF7A30] to-[#E85A20]"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-lg">
              制作実績
            </h1>
            <p className="text-xl md:text-2xl lg:text-3xl text-white drop-shadow-md">
              お客様の想いをカタチにした実績をご紹介します
            </p>
          </div>
        </section>

        {/* Works Grid Section */}
        <section className="py-16 md:py-24 bg-white">
          <div className="px-4 md:px-8 lg:px-16">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-product-shop>
                {worksData.map((work) => (
                  <article
                    key={work.id}
                    className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer"
                  >
                    <div className="relative h-64 md:h-72 overflow-hidden">
                      <img
                        src={work.image}
                        alt={work.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <span className="absolute top-4 left-4 px-3 py-1 bg-white text-primary text-xs font-bold rounded-full shadow-lg">
                        {work.category}
                      </span>
                    </div>
                    <div className="p-6">
                      <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">
                        {work.title}
                      </h3>
                      <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4">
                        {work.description}
                      </p>
                      <button className="inline-flex items-center gap-1 text-primary font-bold hover:text-primary-dark transition-colors whitespace-nowrap cursor-pointer">
                        詳細を見る
                        <i className="ri-arrow-right-line"></i>
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 md:py-24 relative overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/72f95f79575f04d2e5e777734d1956f7.jpeg"
              alt="印刷製品"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/50"></div>
          </div>

          <div className="relative z-10 px-4 md:px-8 lg:px-16">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
                あなたのアイデアを形にします
              </h2>
              <p className="text-lg md:text-xl text-white/90 mb-12">
                お見積もりは無料です。お気軽にご相談ください。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
                <a
                  href="tel:086-012-3456"
                  className="w-full sm:w-auto px-8 py-4 bg-primary text-white rounded-full font-bold text-base md:text-lg hover:bg-primary-dark transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-xl"></i>
                  086-012-3456
                </a>
                <a
                  href="/contact"
                  className="w-full sm:w-auto px-8 py-4 bg-white text-primary border-2 border-primary rounded-full font-bold text-base md:text-lg hover:bg-primary hover:text-white transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-line text-xl"></i>
                  お問い合わせフォーム
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default WorksPage;
